import React from 'react';

export type AvatarSize = 'sm' | 'md' | 'lg';

export interface AvatarProps {
  name?: string;
  src?: string;
  size?: AvatarSize;
  className?: string;
}

export const Avatar: React.FC<AvatarProps> = ({
  name = 'نوازنده',
  src,
  size = 'md',
  className = ''
}) => {
  const sizeClasses: Record<AvatarSize, string> = {
    sm: 'size-9 text-sm',
    md: 'size-10 text-sm',
    lg: 'size-12 text-base'
  };

  const initial = name.trim().charAt(0) || 'ن';

  return (
    <div
      className={`inline-flex items-center justify-center rounded-full bg-base-300 font-bold text-primary-soft select-none shrink-0 overflow-hidden ${sizeClasses[size]} ${className}`}
    >
      {src ? (
        <img src={src} alt={name} className="size-full object-cover" />
      ) : (
        <span>{initial}</span>
      )}
    </div>
  );
};

Avatar.displayName = 'Avatar';
